import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  IconButton,
  Typography,
  Grid,
  Button,
  Paper,
  Avatar,
  Box,
} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ImagesAndFiles = ({
  bannerImg,
  backgroundImg,
  csvFile,
  handleBannerImgChange,
  handleBackgroundImgChange,
  handleCsvChange,
  expanded,
  toggleSection
}) => {
  return (
    <Card
      elevation={3}
      sx={{
        mb: 3,
        borderLeft: '6px solid #ff9800',
        borderRadius: 2,
        backgroundColor: '#fffdf7',
      }}
    >
      <CardHeader
        avatar={<ImageIcon sx={{ color: '#ff9800' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
            Images & Files
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('images')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{
          backgroundColor: '#fff3e0',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          py: 1.5,
          px: 2
        }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent sx={{ px: 3, py: 2 }}>
          <Grid container spacing={4}>
            {/* Banner Image */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                Banner Image
              </Typography>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AddPhotoAlternateIcon />}
                sx={{
                  borderColor: '#ffb74d',
                  color: '#ff9800',
                  mb: 2,
                  '&:hover': {
                    borderColor: '#ff9800',
                    backgroundColor: '#fff8e1'
                  }
                }}
              >
                Upload Banner Image
                <input type="file" accept="image/*" onChange={handleBannerImgChange} hidden />
              </Button>
              {bannerImg && (
                <Paper
                  elevation={2}
                  sx={{ mt: 1, p: 1, width: '100%', maxWidth: 300, borderRadius: 2 }}
                >
                  <Avatar
                    variant="rounded"
                    src={bannerImg}
                    alt="Banner Preview"
                    sx={{ width: '100%', height: 'auto', borderRadius: 2 }}
                  />
                </Paper>
              )}
            </Grid>

            {/* Background Image */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                Background Image
              </Typography>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AddPhotoAlternateIcon />}
                sx={{
                  borderColor: '#ffb74d',
                  color: '#ff9800',
                  mb: 2,
                  '&:hover': {
                    borderColor: '#ff9800',
                    backgroundColor: '#fff8e1'
                  }
                }}
              >
                Upload Background Image
                <input type="file" accept="image/*" onChange={handleBackgroundImgChange} hidden />
              </Button>
              {backgroundImg && (
                <Paper
                  elevation={2}
                  sx={{ mt: 1, p: 1, width: '100%', maxWidth: 300, borderRadius: 2 }}
                >
                  <Avatar
                    variant="rounded"
                    src={backgroundImg}
                    alt="Background Preview"
                    sx={{ width: '100%', height: 'auto', borderRadius: 2 }}
                  />
                </Paper>
              )}
            </Grid>

            {/* CSV File Upload */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                CSV File
              </Typography>
              <Button
                variant="outlined"
                component="label"
                startIcon={<AttachFileIcon />}
                sx={{
                  borderColor: '#ffb74d',
                  color: '#ff9800',
                  '&:hover': {
                    borderColor: '#ff9800',
                    backgroundColor: '#fff8e1'
                  }
                }}
              >
                Upload CSV File
                <input type="file" accept=".csv" onChange={handleCsvChange} hidden />
              </Button>
              <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                {csvFile ? csvFile.name : 'No file selected'}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ImagesAndFiles;
